import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

interface AuthImageContextType {
  imageSrc: string | undefined;
  setImageSrc: (src: string | undefined) => void;
}

const AuthImageContext = createContext<AuthImageContextType | undefined>(
  undefined
);

export const AuthImageProvider = ({
  children,
  defaultImage,
}: {
  children: ReactNode;
  defaultImage?: string;
}) => {
  const [imageSrc, setImageSrcState] = useState<string | undefined>(
    defaultImage
  );

  useEffect(() => {
    if (defaultImage) {
      setImageSrcState(defaultImage);
    }
  }, [defaultImage]);

  const setImageSrc = useCallback((src: string | undefined) => {
    setImageSrcState(src);
  }, []);

  return (
    <AuthImageContext.Provider value={{ imageSrc, setImageSrc }}>
      {children}
    </AuthImageContext.Provider>
  );
};

export const useAuthImage = () => {
  const context = useContext(AuthImageContext);
  if (!context) {
    throw new Error("useAuthImage must be used within an AuthImageProvider");
  }
  return context;
};
